// Silent diagnostics ring buffers - zero cost until a report is opened.
const MAX = 10;
const apiErrors = [];
const consoleErrors = [];

export function recordApiError({ method, url, status, message }) {
  apiErrors.push({
    method: (method || 'GET').toUpperCase(),
    url: String(url || '').slice(0, 200),
    status: status || 0,
    message: String(message || '').slice(0, 300),
    at: new Date().toISOString(),
  });
  if (apiErrors.length > MAX) apiErrors.shift();
}

export function recordConsoleError(message) {
  consoleErrors.push({ message: String(message || '').slice(0, 300), at: new Date().toISOString() });
  if (consoleErrors.length > MAX) consoleErrors.shift();
}

let consoleHooked = false;
export function installConsoleErrorRecorder() {
  if (consoleHooked || typeof window === 'undefined') return;
  consoleHooked = true;
  const original = console.error;
  console.error = (...args) => {
    try {
      recordConsoleError(args.map((a) => (a instanceof Error ? a.message : typeof a === 'string' ? a : '')).filter(Boolean).join(' '));
    } catch (_) { /* never break console */ }
    original.apply(console, args);
  };
  window.addEventListener('unhandledrejection', (e) => {
    try { recordConsoleError(`UnhandledRejection: ${e?.reason?.message || e?.reason || ''}`); } catch (_) { /* noop */ }
  });
}

export function diagnosticsSnapshot() {
  let pwa = false;
  try { pwa = window.matchMedia('(display-mode: standalone)').matches; } catch (_) { /* noop */ }
  return {
    api_errors: [...apiErrors],
    console_errors: [...consoleErrors],
    page: {
      url: window.location.href,
      path: window.location.pathname,
      title: document.title,
    },
    device: {
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      user_agent: (navigator.userAgent || '').slice(0, 180),
      pwa,
      online: navigator.onLine,
    },
    captured_at: new Date().toISOString(),
  };
}

// Global entry point: any component (or non-React code) can raise the
// report-issue flow. ReportIssueHost listens for this event.
export function reportIssue(issueContext = {}, fingerprint = null) {
  window.dispatchEvent(new CustomEvent('akf:report-issue', {
    detail: { issueContext, fingerprint },
  }));
}
